/**
 * @file Performance
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/performance
 */
// 根据兼容顺序取对应浏览器的实现
// TODO: 最后需要 fallback 到自己的兼容实现
const win = typeof window === 'undefined' ? {} : window;
const performance = [
    win.performance,
    win.webkitPerformance,
    win.mozPerformance,
    win.msPerformance,
    {}
].filter(Boolean)[0];

/**
 * @name performance
 * @see https://developer.mozilla.org/zh-CN/docs/Web/API/Performance
 */
export default performance;
